import { Injectable, Inject, RendererFactory2, DOCUMENT } from '@angular/core';

import { LocaleService } from './locale/locale.service';

import type { Renderer2 } from '@angular/core';

import type { LocaleLanguage } from './locale/locale.domain';
import type { PostBootstrapInit } from './post-bootstrap-init';

@Injectable({
  providedIn: 'root'
})
export class PageLangService implements PostBootstrapInit {
  private renderer: Renderer2;

  constructor(@Inject(DOCUMENT) private document: Document,
              @Inject(LocaleService) private localeService: LocaleService,
              @Inject(RendererFactory2) rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init(): void {
    this.setPageLang(this.localeService.getLanguage());
  }

  setPageLang(lang: LocaleLanguage): void {
    if (this.document !== undefined) {
      this.renderer.setAttribute(this.document.documentElement, 'lang', lang);
    }
  }
}
